import MultiPatientConflictDialog from '~/components/Dialogs/MultiPatientConflictDialog';
import usePatientConflictPrompt from '~/hooks/patient/usePatientConflictPrompt';

/**
 * The app's one patient-conflict dialog: shows the conflict any import is
 * asking about and passes the user's answer back to it.
 */
export default function PatientConflictPrompt() {
    const { patientConflict, resolvePatientConflict } =
        usePatientConflictPrompt();
    return (
        <MultiPatientConflictDialog
            conflict={patientConflict}
            onAction={resolvePatientConflict}
        />
    );
}
